var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAnswerBtnLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.11429V3M12 21V16.8857M16.8857 12H21M3 12H7.11429M15.455 8.54546L18.3643 5.63622M5.6354 18.3641L8.54464 15.4549M15.455 15.4545L18.3643 18.3638M5.6354 5.63591L8.54464 8.54515",
    stroke: "#F31825",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAnswerBtnLoad);
export default __webpack_public_path__ + "static/media/AIAnswerBtnLoad.2eb961d9c224673d9bebbe7a2e9ab947.svg";
export { ForwardRef as ReactComponent };